var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTapeMeasureOutline(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#E5C1DA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 23.5c3.5 0 5.117-.415 5.117-3.161 0-4.335-12.545-4.335-12.545-4.335S11 15.71 11 20.339s10.204 5.409 13.577 5.409h23.25c.847 0 1.535.687 1.535 1.535v11.91a5.373 5.373 0 01-5.373 5.373H22.166s-11.152.613-11.152-5.465v-14.65",
    stroke: "#231F20",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.302 37.373v6.705M28.41 34.028v10.05M35.532 37.373v6.705M42.643 34.028v10.05",
    stroke: "#231F20",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.518 21.036c1.124 0 2.035-.337 2.035-.753s-.911-.753-2.035-.753-2.036.337-2.036.753.912.753 2.036.753z",
    fill: "#231F20"
  })));
}
export default SvgTapeMeasureOutline;